<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-6">
      <h2>{{ $t("navigations.subject casebook") }}</h2>
    </div>
    <div class="col-lg-6 d-flex justify-content-end">
      <span class="tooltip-wrapper cursor-pointer" style="float: right">
        <h2 class="text-primary" @click="closePage()">
          Back
        </h2>
        <!-- <i class="fa fa-times close cursor-pointer" @click="$router.push('/siteuserdashboard')"></i> 
            <span class="custom-tooltip closetooltipposition">Close</span>-->
      </span>
    </div>
  </div>
  <div
    class="d-flex wrapper wrapper-content animated fadeInRight px-0 subject-profile-layout"
  >
    <!-- tiles -->
    <div class="col-lg-12 pl-1 p-0 mt-0">
      <div class="card-body p-0">
        <div class="kpi-tiles">
          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center mr-2"
            @click.prevent="showtablepopup('', 'Total AEs')"
          >
            <label>Total AEs</label>
            <h3>{{ tilevalues.totalAEs }}</h3>
          </div>

          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center mr-2"
            @click.prevent="showtablepopup('SEVERE', 'Severe or higher AE')"
          >
            <label>Severe or higher AE</label>
            <h3>{{ tilevalues.grade3PlusAEs }}</h3>
          </div>

          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center mr-2"
            @click.prevent="showtablepopup('SAE', 'SAEs')"
          >
            <label>SAEs</label>
            <h3>{{ tilevalues.saEs }}</h3>
          </div>
          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center"
            @click.prevent="showtablepopup('SUSAR', 'SUSAR')"
          >
            <label>SUSAR</label>
            <h3>{{ tilevalues.susaRs }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-2 px-0">
      <div class="ibox mb-2" v-if="patient">
        <!-- <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mb-0">Subject Information</h5>      
        </div> -->
        <div class="ibox-content">
          <div class="row">
            <div class="col-md-2 bg-white mt-1 p-2 subject-profile-sidebar">
            
              <nav class="subject-profile-sidebar__nav">              
<!-- Forms (flat template list) -->
<a :class="decideclass('Forms')" @click="setselectedmenu('Forms')">
  Forms
</a>
<div v-if="selectedmenu == 'Forms'" class="pl-3 mt-1">
  <div v-if="showFormsLoading" class="text-muted small">
    <i class="fa fa-spinner fa-spin"></i> Loading...
  </div>
  <ul v-else-if="formsTree && formsTree.length > 0" class="list-unstyled" style="font-size: 0.85rem;">
<li v-for="tpl in formsTree" :key="tpl.templateId"
    class="cursor-pointer py-1 px-2 rounded"
    :class="{ 'bg-light': selectedTemplateId === tpl.templateId }"
    @click="selectForm(tpl)">
  <i class="fa fa-file-text-o mr-1"></i>
  {{ tpl.templateName }}
</li>
  </ul>
  <div v-else class="text-muted small">No scheduled forms.</div>
</div>
              </nav>
            </div>
            <div class="col-md-10">
              <div class="row gx-1">
                
<!-- Forms Grid -->
<div v-if="selectedmenu == 'Forms'" class="row" id="forms-section">
  <div class="col-lg-12 pr-1 mb-2">
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5 class="mt-1">Subject Forms</h5>
      </div>
      <div class="ibox-content">
        <!-- Loading indicator -->
        <div v-if="templateFormsLoading" class="text-center py-3">
          <i class="fa fa-spinner fa-spin"></i> Loading forms...
        </div>

        <!-- No forms message -->
        <div v-else-if="!selectedTemplateId" class="alert alert-info">
          Select a template from the sidebar to view its forms.
        </div>

        <!-- Forms table -->
        <div v-else-if="templateForms.length > 0" class="table-responsive" style="max-height: 500px; overflow-y: auto">
          <table class="table table-striped table-bordered">
            <thead style="position: sticky; top: 0; background: white; z-index: 1">
              <tr>
                <!-- Dynamic columns from API (no Action column) -->
                <th v-for="col in dynamicColumns" :key="col">{{ col }}</th>
                 <th class="text-center">View</th>
              </tr>
            </thead>
     <tbody>
  <tr v-for="form in templateForms" :key="form.FormId">
    <td v-for="col in dynamicColumns" :key="col">
      <span v-if="col === 'FormStatus'" :class="getStatusClass(form[col])">
        {{ form[col] || '-' }}
      </span>
      <span v-else-if="col === 'CreatedAt'">
        {{ formatdatetime(form[col]) || '-' }}
      </span>
      <span v-else>{{ form[col] || '-' }}</span>
    </td>
    <td class="text-center">
  <i 
    class="fa fa-eye edit-delete cursor-pointer" 
    @click="viewforms(form)"
    title="View Form"
  ></i>
</td>
  </tr>
</tbody>
          </table>
        </div>
        <div v-else class="alert alert-warning">
          No forms found for this template.
        </div>
      </div>
    </div>
  </div>
</div>
             
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<showformmodel
    class="z-3"
    v-if="setshowFormModal"
    :formid="currentform"
    :isedit="true"
    currentformstatus="Completed"
    @closeformModal="closeformModal()"
/>


</template>
<script src="./subjectcasebook.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "../../components/subject_tree/tree.css";

/* Status badge */
.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}
.badge-red {
  background-color: #ff7163;
  color: #ffffff;
}

.subject-profile-layout {
  flex-wrap: wrap;
}

.subject-profile-sidebar {
  position: sticky;
  top: 16px;
  align-self: flex-start;
  border: 1px solid #e9edf4;
}

.subject-profile-sidebar__title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #667286;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.subject-profile-sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.subject-profile-sidebar__link {
  display: block;
  padding: 0.35rem 0.75rem;
  background-color: #f5f8fc;
  color: #1f2a44;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.subject-profile-sidebar__nav a :active {
  background-color: #f5f8fc;
  color: #4975db;
}

.subject-profile-sidebar__link:hover,
.subject-profile-sidebar__link:focus {
  background-color: #145faf;
  color: #ffffff;
  text-decoration: none;
}
.selectedsubjectmenu {
  background-color: #f5f8fc !important;
  color: #4975db !important;
}

#ae-timeline,
#cm-timeline,
#mh-timeline,
#soa-section,
#subject-schedule-section {
  scroll-margin-top: 20px;
}

@media (max-width: 767px) {
  .subject-profile-sidebar {
    position: static;
    margin-bottom: 0.75rem;
  }
}

/* Scroll area */
.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

/* Flatpickr styling (used inside schedule component) */
:deep(.fp-datetime-input.flatpickr-input),
:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  background-color: #ffffff;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  width: 100%;
  min-height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
}

:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  border-color: #145faf;
}

:deep(input.fp-datetime-input.flatpickr-input.active) {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  display: block !important;
}

:deep(.fp-datetime-input.flatpickr-input:disabled) {
  background-color: #e9ecef;
  cursor: not-allowed;
}

/* Audit trail field */
.audit-link {
  color: #4ba5f0;
  cursor: pointer;
  font-weight: 500;
}

.audit-link:hover {
  text-decoration: underline;
  color: #56a0f0;
}
.patient__invite__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0/18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}
.error-msg {
  color: #ff0000;
}
.patient__invite__modal__container {
  position: fixed;
  width: min(80%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}

.audit__details__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.audit__details__modal__container {
  width: min(90%, 565px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.audit__details__modal__title,
.audit__history__modal__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.heightBig {
  overflow-y: scroll;
  height: 250px;
}

.audit__history__modal__contents {
  overflow-y: scroll;
  height: 404px;
}

.audit__history__modal__wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 4000;
}

.audit__history__modal__container {
  width: min(45%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.headingunderline {
  text-decoration-line: underline;
}

.ibox-content .row > div {
  margin-bottom: 12px;
}

.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}
.compact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem 1rem;
  padding: 0rem;
}
.modal__title {
  background-color: var(--pop-up-background);
  color: hsl(0, 0%, 100%);
}
.save_btn {
  text-align: center;
  background-color: #145faf !important;
  border-color: #145faf !important;
  color: white !important;
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out !important;
}

.save_btn:not(:disabled):hover,
.save_btn:focus:focus-visible {
  background-color: #145faf !important;
  border-color: #145faf !important;
}

/* Each field row – very compact */
.field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 1px solid #f0f3f8;
  padding: 0.05rem 0;
}
.compact-grid-four {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem 1rem;
  padding: 0rem;
}

.field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #667286;
  letter-spacing: 0.2px;
  flex-shrink: 0;
  width: 50%;
}

.field-value {
  font-size: 0.8rem;
  font-weight: 500;
  color: #1f2a44;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-wrap: wrap;
}

.field-full {
  grid-column: span 3;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 1px solid #f0f3f8;
  padding: 0.05rem 0;
}

.field-full .field-label {
  width: auto;
  flex-shrink: 0;
}

.field-full .field-value {
  text-align: right;
}
.tool-tip {
  top: 24px;
}
.consent-field {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.consent-field:last-child {
  border-bottom: none;
}

.consent-field label {
  color: #333;
  margin-bottom: 8px;
}

.consent-field p {
  margin: 0;
  color: #666;
}

.consent-details-card {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 4px;
}
.consent-cards-container {
  display: flex;
  flex-direction: column;
}

.consent-card {
  background-color: #f8f9fa;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.consent-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  background-color: #fff;
}

.card-header-section {
  font-size: 1.1rem;
}
.kpi-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}
.kpi-tile-total {
  border-color: #ff3c3cab !important;
}

.kpi-tile {
  padding: 12px;
  background: #ffffff;
  border-left: 6px solid;
}
.greenstatus {
  color: #08a532;
  background-color: #82f8a32f;
}
.redstatus {
  color: rgb(255, 0, 0);
  background-color: #f4a1a188;
}
.audit-header {
  background: #0c447c;
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: white;
}

.audit-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
}

.audit-meta {
  display: flex;
  gap: 18px;
  margin-top: 8px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #b5d4f4;
}

.audit-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.audit-status {
  background: #1d9e75;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  color: #ffffff;
  float: right;
  flex-direction: row;
}

.audit-close {
  border: none;
  background: transparent;
  color: white;
  font-size: 22px;
  cursor: pointer;
}

.audit-summary {
  padding: 14px 22px;
  display: flex;
  gap: 10px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 12px;
  color: #666;
}

.audit-event-list {
  max-height: 500px;
  overflow-y: auto;
  padding: 20px;
}

.audit-event-wrapper {
  display: flex;
  gap: 14px;
}

.audit-timeline {
  width: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.audit-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.audit-line {
  width: 2px;
  flex: 1;
  background: #ddd;
  margin-top: 4px;
}

.audit-content {
  flex: 1;
  padding-bottom: 18px;
}

.audit-card {
  border-radius: 10px;
  padding: 4px 8px;
  transition: 0.2s;
}

.audit-card:hover {
  background: #f8f9fb;
}

.audit-badges {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.event-badge {
  padding: 1px 6px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
}

.audit-date {
  font-size: 11px;
  color: #777;
}

.audit-message {
  margin-top: 4px;
  font-size: 12px;
  color: #222;
}

.audit-user-row {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 2px;
  flex-wrap: wrap;
}

.audit-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e6f1fb;
  color: #185fa5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
}

.audit-user {
  font-size: 12px;
  color: #444;
}

.audit-user-type {
  font-size: 11px;
  color: #888;
}

.audit-success {
  margin-left: auto;
  background: #eaf3de;
  color: #3b6d11;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}
.audit-metadata-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 6px;
  margin-top: 2px;
  cursor: pointer;
  user-select: none;
  border-radius: var(--border-radius-md);
  transition: background 0.15s;
  font-size: 12px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.audit-metadata-toggle:hover {
  background: var(--color-background-secondary);
}

.audit-metadata-toggle i {
  transition: transform 0.2s;
}

.audit-metadata-toggle i.metadata-expanded {
  transform: rotate(180deg);
}

.audit-metadata-section {
  -background: #f8fafc;
  border: 1px solid #e6edf5;
  border-radius: 8px;
  padding: 2px 6px;
  margin-top: 2px;
}
.audit-metadata-row {
  display: flex;
  align-items: flex-start;
  padding: 0px 0;
  border-bottom: 1px solid #eef2f7;
  gap: 7px;
}
.audit-metadata-row:last-child {
  border-bottom: none;
}

.audit-metadata-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 16px;
}

.audit-metadata-item {
  display: flex;
  flex-direction: column;
}

.audit-metadata-key {
  width: 140px;
  min-width: 140px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.04em;
}
.audit-metadata-separator {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 600;
}

.audit-metadata-value {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: #1f2937;
  word-break: break-word;
}
.wet-ink-info {
  border-radius: 8px;
  font-size: 13px;
}

.upload-zone {
  border: 2px dashed #5b9cff;
  border-radius: 8px;
  padding: 25px;
  text-align: center;
  cursor: pointer;
  background: #f5f9ff;
  transition: all 0.2s;
}

.upload-zone:hover {
  background: #edf5ff;
  border-color: #2563eb;
}
.invite-left-panel {
  padding: 20px;
  width: 290px;
  min-width: 290px;
  border-right: 1px solid #e4e9f2;
  background: #fff;
  overflow-y: auto;
  max-height: 440px;
}

/* Optional scrollbar styling */
.invite-left-panel::-webkit-scrollbar {
  width: 6px;
}

.invite-left-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.invite-left-panel::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.invite-left-panel::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.info-box {
  border-radius: 7px;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.65;
  margin-bottom: 14px;
}
.info-box.blue {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1e40af;
}
.info-box.amber {
  background: #fffbeb;
  border: 1px solid #fcd34d;
  color: #92400e;
}
.info-title {
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.info-box ol {
  padding-left: 15px;
  margin-top: 6px;
}
.info-box ol li {
  margin-bottom: 3px;
}
.upload-zone {
  border: 2px dashed #93c5fd;
  border-radius: 8px;
  padding: 16px 12px;
  text-align: center;
  cursor: pointer;
  background: #f0f7ff;
  margin-bottom: 12px;
  transition: background 0.15s;
}
.upload-zone:hover {
  background: #dbeafe;
}
.upload-zone i {
  font-size: 24px;
  color: #2563eb;
  display: block;
  margin-bottom: 6px;
}
.uz-label {
  font-size: 12px;
  color: #1e40af;
  font-weight: 600;
}
.uz-sub {
  font-size: 11px;
  color: #3b82f6;
  margin-top: 3px;
}
.file-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ecfdf5;
  border: 1px solid #6ee7b7;
  border-radius: 7px;
  padding: 8px 10px;
  font-size: 12px;
  color: #065f46;
  margin-bottom: 12px;
}
.file-badge i {
  color: #059669;
  font-size: 16px;
}
.fb-name {
  flex: 1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fb-remove {
  cursor: pointer;
  color: #059669;
  font-size: 14px;
}
.fb-remove:hover {
  color: #dc2626;
}
.subject-alert-success {
  color: #0f5132;
  background-color: #ecfdf5;
  border-color: #6ee7b7;
}
</style>
